import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import styled, {css} from 'styled-components'

export const StyledDeceasesGroupsGrid = styled(Grid)(
    ({theme: {mediaQueries}}) => css`
        ${mediaQueries['2xl']} {
            grid-template-columns: repeat(3, 1fr);
        }
    `
)
